<template>
  <div class="modal">
    <div class="content" v-if="!isFail">
      <div class="gold">
        <img src="../../assets/images/gold.png" width="100%" alt="" />
        <div class="text">
          <span>赠送鲜花将扣除10个积分</span>
          <span>是否继续赠送？</span>
        </div>
        <div class="myCoin">我的积分：{{coin}}</div>
      </div>

      <div class="btns">
        <div class="continueBtn" @click="giveLikeMethod(notTips)">继续赠送</div>
        <div class="giveUpBtn">
          <span @click="closeModal">放弃送花</span>
        </div>
      </div>

      <div class="noMoreTip">
        <div class="box" @click="changeNotTips">
          <div class="icon">
            <img
              :src="
                notTips
                  ? require('../../assets/images/pass.png')
                  : require('../../assets/images/tipsChoose.png')
              "
              width="100%"
              alt=""
            />
          </div>
          <div class="text">不再提示</div>
        </div>
      </div>
    </div>

    <div class="failModal" v-else>
      <div class="pic">
        <img src="../../assets/images/failTips.png" width="40px" alt="" />
      </div>
      <div class="text">您的积分不足，赠送失败</div>
      <div class="btn">我知道了</div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import http from "../../utils/http";
export default {
  name: "LikeModal",
  components: {
    // [Notify.Component.name]: Notify.Component,
  },
  data() {
    return {
      isFail: false,
      notTips: false,
      coin:0, // 积分
    };
  },
  methods: {
    // 切换不再提示
    changeNotTips() {
      this.notTips = !this.notTips;
    },

    // 关闭模态框
    closeModal() {
      this.$emit("closeModal");
    },

    // 确认送花
    giveLikeMethod() {
      // if(this.coin < 5){
      //   Toast('积分不足')
      //   this.closeModal()
      //   return
      // }
      this.closeModal()
      this.$emit('giveLikeCallBack',this.notTips)
    },
  },
  created(){
    http.getUserInfo().then(res=>{
      console.log(res)
      if(res){
        this.coin = res.integral
      }
    })
  }
};
</script>

<style scoped lang='less'>
.modal {
  display: flex;
  align-items: center;
  z-index: 99999;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(20, 19, 26, 0.8);
  .content {
    width: 90%;
    margin: 0 auto;
    .gold {
      margin: 0 auto;
      width: 190px;
      position: relative;
      margin-bottom: 20px;
      .text {
        position: absolute;
        bottom: 22px;
        left: 0;
        width: 100%;
        span {
          display: block;
          font-size: 15px;
          text-align: center;
          color: #fff;
        }
      }
      .myCoin {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        text-align: center;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.85);
      }
    }
    .btns {
      width: 100%;
      border-bottom: 1px solid #605f64;
      padding-bottom: 10px;
      margin-bottom: 24px;
      .continueBtn {
        width: 220px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color: #fff;
        background: linear-gradient(90deg, #ff7337 49%, #fc541e 100%);
        border-radius: 20px;
        font-size: 15px;
        font-weight: 400;
        margin: 0 auto;
        margin-bottom: 6px;
      }
      .giveUpBtn {
        width: 100%;
        display: flex;
        justify-content: center;
        color: #fff;
        font-size: 15px;
        height: 40px;
        line-height: 40px;
      }
    }
    .noMoreTip {
      display: flex;
      justify-content: center;
      .box {
        display: flex;
        align-items: center;
        .icon {
          width: 16px;
          img {
            display: block;
          }
        }
        .text {
          margin-left: 5px;
          font-size: 15px;
          color: #fff;
        }
      }
    }
  }
  .failModal {
    // width: 90%;
    // margin: 0 auto;
    width: 100%;
    margin: 0px 24px;
    background-color: #fff;
    border-radius: 6px;
    text-align: center;
    .pic {
      height: 100px;
      display: flex;
      align-items: center;
      img {
        margin: 0 auto;
        display: block;
      }
    }
    .text {
      font-size: 15px;
      color: rgba(34, 32, 48, 0.65);
      padding-bottom: 32px;
      border-bottom: 1px solid rgba(34, 32, 48, 0.1);
    }
    .btn {
      height: 54px;
      line-height: 54px;
      color: #222030;
      font-size: 16px;
      font-weight: 400;
    }
  }
}
</style>